$( document ).ready(function() {

function updateHeight() {
    var height = $(".cstm-jtpl use-animate.cstm_use-animate ul li modal-opener").height();

    $(".cstm-jtpl .cstm_thumbnail_jt .thumbnail-slider ul").css({
        "max-height": `calc(${height}px - 56px)`,
        "overflow": "hidden"
    });
}
updateHeight();
$(window).on("resize", function () {
    updateHeight();
});
 

 var datamediapostion=$(".thumbnail-list").attr("data-media-count");
console.log("dd",datamediapostion);
var datalistid =$(".thumbnail-list__item ").length;
console.log("datalistid ",datalistid );
var datacolor=$('.product__media-item').attr("data-gang-connect");
console.log("datacolor",datacolor)

 $('.custom_collection_list_slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow:4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-chevron" fill="none" viewBox="0 0 100 100"><path fill-rule="evenodd" clip-rule="evenodd" d="M 10,50 L 60,100 L 60,90 L 20,50  L 60,10 L 60,0 Z" fill="currentColor"></path></svg></div>',
  nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-chevron" fill="none" viewBox="0 0 100 100"><path fill-rule="evenodd" clip-rule="evenodd" d="M 10,50 L 60,100 L 60,90 L 20,50  L 60,10 L 60,0 Z" fill="currentColor"></path></svg></div>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,


      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
      }
    }
  ]
});

  $('.cstm-tabs:first').addClass('active-content');
    $('.tab-heading:first').addClass('active-tab');
  
 $(document).on("click", '.tab-heading', function(e){
    e.preventDefault();
    
    var shownumber = $(this).index();
   
    $('.tab-heading').removeClass('active-tab');
     $('.cstm-tabs').fadeOut(500).removeClass('active-content');
   
      $(this).addClass('active-tab');
    $('.cstm-tabs').each(function (i) {
        if(i == shownumber){
      $(this).fadeIn(500).addClass('active-content');
       }
         })
});
  
if ($(window).width() > 767) {  
 
$('.product-media-modal-mobile').remove();
}else{
 
  $('.product-media-modal__content-desktop').remove();
}
 
if ($(window).width() > 767) {   
var modal_html = $('.product-media-modal__content-desktop').html();
//alert(modal_html);
var selected_color = $('input:checked').next('.color__swatch').attr('selected-color');
 $('.product-media-modal__content-desktop  .media-wrapper').each(function () {
      var all_attr = $(this).attr('selected-color');
      if(selected_color != all_attr){
         
          $(this).addClass('removeimages');
      }else{
           (selected_color +'=='+ all_attr);
          $(this).removeClass('removeimages');
      }
  })
 setTimeout (function(){
$('.removeimages').remove();
  },200);
 setTimeout (function(){
$('.product-media-modal__content-desktop').slick({
 dots: true,
  infinite: true,
 slidesToShow: 1,
  slidesToScroll: 1
});
 },230);
  function ShowModalImages() {
  $(document).on('click','.color__swatch', function () {
   $('.product-media-modal__content-desktop').html(modal_html);
    var swatch_title = $(this).attr('selected-color');
      
  $('.product-media-modal__content-desktop  .media-wrapper').each(function () {
      var all_attr = $(this).attr('selected-color');
      if(swatch_title != all_attr){
          $(this).addClass('removeimages');
      }else{
          //alert(selected_color +'=='+ all_attr);
           $(this).removeClass('removeimages');
      }
  })
    })
}
 $(document).on('click','.color__swatch-dot', function () {
   console.log('clickeddd');
   $('.product-media-modal__content-desktop').slick('unslick');
  setTimeout (function(){
  ShowModalImages();
    //console.log('yes run');
     },170);
    setTimeout (function(){
  ShowModalImages();
    //console.log('second time run');
     },200);
 setTimeout (function(){
$('.removeimages').remove();
  },130);
setTimeout (function(){
  $('.product-media-modal__content-desktop').slick({
 dots: true,
  infinite: true,
 slidesToShow: 1,
  slidesToScroll: 1
});
},200); 
  })
$(document).on('click','.cstm-size-option', function () {
  $('.product-media-modal__content-desktop').slick('unslick');
setTimeout (function(){
  $('.product-media-modal__content-desktop').slick({
 dots: true,
  infinite: true,
 slidesToShow: 1,
  slidesToScroll: 1
});
},800); 
})

$(document).on('click','.thumbnail-list__item', function () {
$('.product-media-modal__content-desktop').slick('unslick');
setTimeout (function(){
  $('.product-media-modal__content-desktop').slick({
 dots: true,
  infinite: true,
 slidesToShow: 1,
  slidesToScroll: 1
});
},200); 
})
}
showarrows();
  function showarrows(){
 
  var getLenght = $('li.thumbnail-list__item.slider__slide.media-wrapper.media-wrapper--small.gang__active').length;
        if(getLenght > 5){
$('.icon-up-jtpl').show();
   $('.icon-jtpl-down').show();
        }else{
// $('.icon-up-jtpl').hide();
//    $('.icon-jtpl-down').hide();

        }
        
    }
$('body').on('click','.variant-input-wrapper',function () {
    showarrows();
})

  // thumbnails slider arrow end
        setTimeout(function() {
 var getText = $('button#addtoCart').text();
if(getText == 'Sold out' || getText == 'Unavailable'){
  console.log('yes');
$('.product__info-wrapper.grid__item').addClass('notify_me_eamil');
}else{
    console.log('no');
$('.product__info-wrapper.grid__item').removeClass('notify_me_eamil');

}
        
        }, 100);
  //alert();
var stickyHeader = $('.shopify-section-header').height();
$('.shopify-section-header + .shopify-section-announcement-bar').css('top', stickyHeader);
console.log(stickyHeader);

  var stickyHeader1 = $('header.header').height();
$('header.header + .shopify-section-announcement-bar').css('top', stickyHeader);
console.log(stickyHeader1);
  // product page custom swatch start
var getTitle = $('.product__title .product__heading').attr('attr');
console.log(getTitle);
$('ul.custom_product_list li').each(function () {
   var getHandle = $(this).attr('attr');
  // console.log(getHandle);
    var getSplit = getHandle.split('/');
    var url = getSplit[4];
    console.log(url);
    if(getTitle == url){
        $(this).addClass('is-product-swatch-active');
      $(this).removeClass('is-product-swatch-notactive');
      console.log('yes');
    }else{
         $(this).removeClass('is-product-swatch-active');
       $(this).addClass('is-product-swatch-notactive');
console.log('no');
    }
});
    $('.cstm-tab').click(function() {
        var input = this;
        input.disabled = true;
        setTimeout(function() {
           input.disabled = false;
        }, 3000);

    }); 

  $('li.is-product-swatch-active a').removeAttr('href');
  // product page custom swatch end
var url = window.location.href;
  if(url.indexOf("/cart") > -1){
    var handleCart = setInterval(cartButtons,10);
  
  function cartButtons(){
    if( $("div.shopify-cleanslate ul").length > 0){
       $("div.shopify-cleanslate ul").attr("style","display:flex!important; flex-wrap: wrap!important;flex-direction:row!important; gap:5px; justify-content: center;");
      $(".shopify-cleanslate").css("display", "block");
      clearInterval(handleCart);
    }
   
  }
  }
  
// $(document).on("click", '.popup-close', function(){
//   var popup = $('.popup').attr("style");
//   console.log(popup);
//   if ( popup == 'opacity: 0.990545;' || popup == 'display:none;') {
//     $('.promo-popup')removeClass('is-active');
//   }

// });
  var gettex = $('span.cart-count-bubble span:first').text();
console.log(gettex);
if(gettex > 0){
$('section#shopify-section-template--14921154035797__cart-items , section#shopify-section-template--14921154035797__cart-footer').wrapAll('<div class="custom_cart_wrapper"></div>');
}
  $(window).scroll(function (event) {
     event.preventDefault();
    var scrollDistance = $(window).scrollTop();
  // console.log("dispance" + scrollDistance)
    $('.article-section').each(function (i) {
      // console.log("check" + i)
      if ($(this).position().top <= 5) {
        $('.js-navigation-list .js-navigation-item.active').removeClass('active');
        $('.js-navigation-list .js-navigation-item').eq(i).addClass('active');
      }
    });
}).scroll();

  
$(document).on("click" , '.list_collection_products_list_href' , function() {
    $('html, body').animate({
      scrollTop: $( $(this).attr('href') ).offset().top - 160
    }, 1000);
    return false;
});

// not usable bcz show more removed by filter  
// setTimeout(function() {
// $('.cstm_less').hide(); 
// }, 2000);
// $(document).on('click' , '.cstm_more' , function(){
// var btn = $(this).hide()
//   console.log(btn);
//   $(this).parents('.button-show-more').find('.cstm_less').show();
// });
// $(document).on('click' , '.cstm_less' , function(){
// var btn = $(this).hide();
//   console.log(btn);
//   $(this).parents('.button-show-more').find('.cstm_more').show();
// });



// var recently_view = localStorage.getItem("beyours:recently-viewed");
// recently_view_pro =   recently_view.split(',');
// var  new_recent =  recently_view_pro.length;
// console.log(new_recent);
// if ( new_recent >= 2 ){
// $('product-recommendations').hide();
// }
 
$(".icon-jtpl-down").on("click", function() {
  var currentPosition = $(".thumbnail-list").scrollTop();
  var currentPositionNew = currentPosition + 300;
  $(".thumbnail-list").scrollTop(currentPositionNew);
});


$(".icon-up-jtpl ").on("click", function() {
  var currentPosition = $(".thumbnail-list").scrollTop();
  var currentPositionNew = currentPosition - 300;
  $(".thumbnail-list").scrollTop(currentPositionNew);
});

  
var scrollTop = $('.thumbnail-list.custom_slider_jtpl').scrollTop();
  if (Math.round(scrollTop + $(this).innerHeight()) >= this.scrollHeight) {
      $('.icon-jtpl-down').addClass('disable-icon');
     $('.icon-up-jtpl').removeClass('disable-icon');
  } else if (scrollTop <= 0) {
     $('.icon-jtpl-down').removeClass('disable-icon');
    $('.icon-up-jtpl').addClass('disable-icon');
}  

 
$('.thumbnail-list.custom_slider_jtpl').on('scroll', function() {
  var scrollTop = $(this).scrollTop();
    //console.log(Math.round(scrollTop + $(this).innerHeight()) +'='+ this.scrollHeight)
  if (Math.round(scrollTop + $(this).innerHeight()) >= this.scrollHeight) {
      $('.icon-jtpl-down').addClass('disable-icon');
     $('.icon-up-jtpl').removeClass('disable-icon');
  } else if (scrollTop <= 0) {
     $('.icon-jtpl-down').removeClass('disable-icon');
    $('.icon-up-jtpl').addClass('disable-icon');
  } else {
    
  }
});
  
 
// $('.js-filter').each(function(){
//    var filter = $('.js-filter').attr('aria-expanded');
//   console.log(filter);
// });


  
$(document).on('click' , '.mellanni-in-the-press .multicolumn-list li' , function(){
  
  var id1 = $(this).attr('data');
  var id = $(this).find('.image-animate img').attr('src');
  $('.popup__content img').attr('src' , id )
  $("body").addClass('popup_open_press_jtpl'); 
  $(".popup-jt").fadeIn(100);
});


$('.cstm_jtpl_press_popup').click(function() {
  $('.close').trigger('click');
});  
$('.popup-jt').click(function(event){
   event.stopPropagation();
});
$(".close").click(function() {
  $(".popup-jt").fadeOut(500);
  $("body").removeClass('popup_open_press_jtpl');
  $("div.popup_imgae img").attr('src', '');
});



$('.slider_cstm').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    }
  ]
});


  
  
// $(".multicolumn_clicker").click(function() {
//   $(".popup").fadeIn(500);
// });

  
  // setTimeout(function(){
  //   if($("body").hasClass("template-product")){
  // var color =   $(".product-form__input[data-option-slug='color']").find("input[type=radio]:checked").val();
  //     console.log(color);
  //     var colorLower = color.toLowerCase();
  //      console.log(colorLower);
     
  //   var slickNumber =  $(".custom_slider_jtpl").find("li[data-gang-connect=color_"+colorLower+"]").attr("data-slick-index");
  //       console.log(slickNumber);
  //   $('.custom_slider_jtpl').slick('slickGoTo', slickNumber);
  // }
  // },5000);
  
  
// $(document).on('click','.thumbnail-list__item',function(){
//    var postion = $(this).attr('data-media-position');
//     $('.product__media-item').removeClass('is-active');
//     $('.product__media-item[data-media-position="'+postion+'"]').addClass('is-active')
// });



$('.thumbnail-slider').removeClass('hidden');  

// slider for desktop
//var SliderInterval = setInterval(SliderInitCustom, 50);
// function SliderInitCustom() {
// var $windowWidth = $(window).width();
// if ($windowWidth > 749) {
//   setTimeout(function() {
// $('.thumbnail-slider').removeClass('hidden');
// }, 3000);
  
//   $('.custom_slider_jtpl').slick({
//     autoplay: false,
//     arrows: true,
//     dots: false,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     centerPadding: "10px",
//     draggable: false,
//     infinite: true,
//     pauseOnHover: false,
//     swipe: true,
//     touchMove: false,
//     vertical: true,
//     speed: 1000,
//     autoplaySpeed: 2000,
//     useTransform: true,
//     cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
//     adaptiveHeight: true,
//     arrows: true,
//     prevArrow: '<div style="background : transparent;"><span class="prev-btn"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024"><path fill="currentColor" d="m488.832 344.32l-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872l319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0"/></svg></button></div>',
//     nextArrow: '<div style="background : transparent;"><span class="next-btn"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024"><g transform="rotate(180 512 512)"><path fill="currentColor" d="m488.832 344.32l-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872l319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0"/></g></svg></button></div>'
// });
// } 
// clearInterval(SliderInterval);
// var $windowWidth1 = $(window).width();
// if ($windowWidth1 <= 749) {
// $('.custom_slider_jtpl').slick("unslick");
// }

// }
  
// slider on load 
// $(document).on('click' , '[clicker], .color__swatch' , function(){
// setTimeout(function() {
// $('.thumbnail-slider').removeClass('hidden');
// }, 3000);
  
// if($("ul.custom_slider_jtpl").hasClass('slick-initialized')){
//    $('.custom_slider_jtpl').slick("unslick");
//     console.log("Unslicked..")
// }

// $('.custom_slider_jtpl').slick({
//    autoplay: false,
//     arrows: true,
//     dots: false,
//     slidesToShow: 4,
//     centerPadding: "10px",
//     draggable: false,
//     infinite: true,
//     pauseOnHover: false,
//     swipe: true,
//     touchMove: false,
//     vertical: true,
//     speed: 1000,
//     autoplaySpeed: 2000,
//     useTransform: true,
//     cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
//     adaptiveHeight: true,
//     arrows: true,
//     prevArrow: '<span class="prev-btn"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024"><path fill="currentColor" d="m488.832 344.32l-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872l319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0"/></svg></span>',
//     nextArrow: '<span class="next-btn"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024"><g transform="rotate(180 512 512)"><path fill="currentColor" d="m488.832 344.32l-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872l319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0"/></g></svg></span>'
// });    
// });



// announcement for mobile
var interval_ann = setInterval(SliderInitCustom1, 50);
function SliderInitCustom1() {
$(window).resize(function(){  
  // Slider_Slu();
var $windowWidth3 = $(window).width();
if ($windowWidth3 <= 749) {
var class_name = $('announcement-bar').attr('data-layout');
 if ( class_name = "fixed" ){ 
 var announcement = $('announcement-bar').attr('data-layout');
 $('announcement-bar').addClass(announcement);
 $('announcement-bar').removeClass('marquee');
  $('.jtpl_annocement_tet').addClass('announcement-slider__slide');
 }
  clearInterval(interval_ann);
}
});
}
// announcement for desktop
var interval_ann1 = setInterval(SliderInitCustom11, 50);
function SliderInitCustom11() {
$(window).resize(function(){  
    var $windowWidth4 = $(window).width();
if ($windowWidth4 >= 749) {
var class_name = $('announcement-bar').attr('data-layout');
 if ( class_name = "fixed" ){ 
 var announcement = $('announcement-bar').attr('data-layout');
 $('announcement-bar').addClass(announcement);
 $('announcement-bar').removeClass('marquee');
  $('.jtpl_annocement_tet').removeClass('announcement-slider__slide');
 }
clearInterval(interval_ann1);
}
});
}
  
// on load announcemet
var ss = setInterval(st, 50);
function st () {
var $windowWidth5 = $(window).width();
if ($windowWidth5 <= 749) {
var class_name = $('announcement-bar').attr('data-layout');
if ( class_name = "fixed" ){
var announcement = $('announcement-bar').attr('data-layout');
$('announcement-bar').addClass(announcement);
$('announcement-bar').removeClass('marquee');
$('.jtpl_annocement_tet').addClass('announcement-slider__slide');
}
   window.dispatchEvent(new Event('resize'));
   clearInterval(ss);
}
}






$('.custom-icon, .icon-dropdown').hover(function() {
    $('.icon-dropdown').toggleClass('toggled');
    $('.custom-overlay-jtpl').toggleClass('toogle_btn_body_overlay');
    $('header').toggleClass('toggle_btn_overlay_header');
     $('body').toggleClass('contact_body_popup_jtpl');
});



  
$('.product__media-item').addClass('gang__active');
$('#shopify-section-sections--14895300411477__header').addClass("shopify-section-header-sticky");  
  


  
var selected_id = $('#product_temp').attr('data-id');
$('.accordion__content .UPC').hide();
$('.accordion__content .UPC[v_id="Variant_id-'+selected_id+'"]').show();
$('.variant-Base').hide();
$('.variant-Base[data_id="variant_id-'+selected_id+'"]').show();
var mixmatchdata = $('.variant-Base[data_id="variant_id-'+selected_id+'"]').text();
  //console.log("Custom-js.log"+mixmatchdata)
  if ( mixmatchdata.indexOf('Add to cart') > -1){
    $('.mixmatch-heading').show();
  }else{
    $('.mixmatch-heading').hide();
  }
  // $('.mixmatch-heading').show();
  // console.log(mixmatchdata)
  // if(mixmatchdata.indexOf('recomended-product')){
  //   $('.mixmatch-heading').hide();
  // }
  // else {
  //   $('.mixmatch-heading').show();
  // }
  

  
// $(".custom-overlay-jtpl").click(function () {
// $(".custom-overlay-jtpl").removeClass("toogle_btn_body_overlay");
//   $(".icon-dropdown").removeClass("toggled");
//   $('header').removeClass('toggle_btn_overlay_header');
//   $('body').removeClass('contact_body_popup_jtpl');
// }); 
  
$(".clicker").click(function () {
$(".show-description").show();
});

$('body').click(function() {
   $(".show-description").hide();
});
  
$('.clicker').click(function(event){
   event.stopPropagation();
});
$(".show-description").hide();



// --------Start add to cart button ajax-----------//
   $( "#target" ).on( "click", function() {
   // alert(8)
   var getAttr = $(this) .attr('data-id');
    // alert(getAttr);
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {
              quantity: 1,
              id: getAttr
          },
        dataType: 'json', 
        success: function (data) { 
        $.ajax({
            url: '/cart',
            type: "GET",
            dataType: "html",
            success: function(data) {
              var get = $("cart-drawer-items").html();
                $("cart-drawer-items").html($(data).find('cart-drawer-items').html());
                   },
                });
               } 
             });
          });
// --------End add to cart button ajax-----------//


});


$('.right-side-content quick-view-button').click(function(){
$('.custom_loader_jtpl').show();
  var cstm_url = $(this).attr('data-product-url');
  $.ajax({
    url: cstm_url,
    type: 'GET',
    dataType: 'html',
    success: function(data) {
      // Target the specific div within the received data
      var productDiv = $(data).find('.product.thumbnail_slider');

      // Access the div's content or attributes as needed
      var productContent = productDiv.html();
      
      var productImage = productDiv.find('.shopify-block.shopify-app-block').html();
$('.custom_quick_jtpl_wrapper').show();
$('body').addClass('cart-quick-is-active');
      console.log(productContent);
      console.log(productImage);
      $('.custom_loader_jtpl').hide();
        $('.quick-view').html(productContent)
      var getRate = $('.custom_quick_jtpl_wrapper span.stamped-product-reviews-badge').html();
$(getRate).insertAfter('.quick-view.custom_quick_jtpl h1.product__heading.h2');
      //$('.custom_quick_jtpl_wrapper span.stamped-product-reviews-badge.stamped-main-badge').html(getHtml);
  setTimeout(function() {
    
         $('.product__media-list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
arrows: true,
    prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path fill="#000000" d="m16 8l1.43 1.393L11.85 15H24v2H11.85l5.58 5.573L16 24l-8-8z"/><path fill="#000000" d="M16 30a14 14 0 1 1 14-14a14.016 14.016 0 0 1-14 14m0-26a12 12 0 1 0 12 12A12.014 12.014 0 0 0 16 4"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path fill="#000000" d="m16 8l-1.43 1.393L20.15 15H8v2h12.15l-5.58 5.573L16 24l8-8z"/><path fill="#000000" d="M16 30a14 14 0 1 1 14-14a14.016 14.016 0 0 1-14 14m0-26a12 12 0 1 0 12 12A12.014 12.014 0 0 0 16 4"/></svg></div>'
  
});

 }, 100);
    }
  });
});
$('.custom_quick_jtpl_svg').click(function () {
    $('.custom_quick_jtpl_wrapper').hide();
  $('body').removeClass('cart-quick-is-active');
})
// product size variant width
var max_size = 0
$('.cstm-size-option').each(function () {
    var radio_size_width = $(this).width();
    if(radio_size_width > max_size){
        max_size = radio_size_width;
    }
})
$('.cstm-size-option').width(max_size);




function showSecondImage(){
 var getTotalLen = $('.thumbnail-list__item:visible').length-1;
var getFirst_id = $('.thumbnail-list__item:visible').attr('data-target');
  console.log(getFirst_id);
$('.thumbnail-list__item').click(function(){
     $('.product__media-item').removeClass('is-active').css('order',0)
    var this_index =  $(this).index();
    var this_id = $(this).attr('data-target');
    var next_id = $(this).next('.gang__active').attr('data-target');
     $('.product__media-item').each(function(){
        var get_id = $(this).attr('data-media-id');
        if(this_index != getTotalLen){
            
         if(this_id == get_id || get_id == next_id){
             $(this).addClass('is-active');
     
        }}else{
            
           if(this_id == get_id){
             $(this).addClass('is-active').css('order',1);
           }
        if(get_id == getFirst_id){
                $(this).addClass('is-active').css('order',2);
            }
        }
       })
    })


}
function onloadshowdata(){
   var loadattr = $('.thumbnail-list__item.gang__active').eq(1).attr('data-target');
$('.product__media-item').each(function(){
var get_new_id = $(this).attr('data-media-id');
     if(get_new_id == loadattr){
             $(this).addClass('is-active');
     }}) 
}
 setTimeout(function(){
    onloadshowdata();
  },1000)
  
  setTimeout(function() {
showSecondImage();
}, 1000);

$(document).on('click','.color__swatch,.cstm-size-option',function(){
  $('.product__media-item').removeClass('is-active').css('order',0)
  setTimeout(function(){
    onloadshowdata();
  },600)
  setTimeout(function(){
   showSecondImage(); 
  },1400);
  
})